import React from 'react'
import { signOut } from 'next-auth/react'

import { ButtonV2, Popover, PopoverContent, PopoverTrigger } from '@fsg/gui-bits'
import { User } from '@fsg/next-auth'
import { UserImage } from '../UserImage'
import { Hamburger } from '@app/styles/design-system/svg/icons'

interface Props {
  className?: string
  user: User
}

function getInitials(name: string): string {
  return name.charAt(0).toUpperCase()
}

export function NameBubble({ className, user }: Props) {

  return (
    <Popover>
      <PopoverTrigger className="grow-0">
        <div className='flex items-center p-3xs pr-sm gap-2xs border border-gray-400 rounded-lg hover:bg-gray-200'>
          <div
            className=
            'flex h-[28px] w-[28px] items-center justify-center rounded-full bg-gray relative'
          >
            <UserImage width={28} height={28} className='absolute' />
            <span className="p-sm text-xs font-semibold text-gray-darker-500">
              {getInitials(user?.name || '')}
            </span>

          </div>
          <Hamburger className='w-[16px] h-[16px]' />
        </div>
      </PopoverTrigger>
      <PopoverContent className="mx-5 my-3 grid justify-items-center text-xs font-semibold">
        <h2 className="text-gray-dark">{user?.name}</h2>
        <ButtonV2
          className="mt-3 text-sm font-semibold text-white"
          variant="primary"
          onClick={() => signOut()}
        >
          <span>Logout</span>
        </ButtonV2>
      </PopoverContent>
    </Popover>
  );
}